import {Shortcuts} from 'shortcuts';
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {
    CUSTOM_SHORTCUT_CHANGE_OPERATOR_STATUS_TYPE_ID,
    CUSTOM_SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO_TYPE_ID,
    CUSTOM_SHORTCUT_SEND_FORM_TYPE_ID,
    CUSTOM_SHORTCUT_SEND_INFO_TYPE_ID,
    CUSTOM_SHORTCUT_START_BOT_TYPE_ID,
    CUSTOM_SHORTCUT_USE_MESSAGE_TEMPLATE_TYPE_ID,
    CustomShortcutChangeOperatorStatusPayloadInterface,
    OperatorApplicationConfigInstance,
    SHORTCUTS_CHANGED_EVENT
} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import {ShortcutDescriptor} from "shortcuts/dist/types";
import {
    SHORTCUT_INSERT_MESSAGE_TEMPLATE,
    SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO,
    SHORTCUT_SEND_TAB,
    SHORTCUT_START_BOT,
    ShortcutsList
} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import {COPY_SHORTCUT, OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {SendTabShortcutPayloadInterface} from "~/operatorApplication/ts/service/shortcuts/CustomShortcutTypes";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import setOperatorStatus from "~/operatorApplication/ts/service/status/SetOperatorStatus";

const shortcuts = new Shortcuts({
    capture: true
});

OperatorApplicationEventManager.addEventListener(SHORTCUTS_CHANGED_EVENT, () => {
    OperatorApplicationShortcutsInstance.init();
});


class OperatorApplicationShortcuts {
    record(handler: (hotkey: string) => void): Function {
        return shortcuts.record(value => {
            let split = value.split(" ");
            if (split.length > 0) {
                handler(split[split.length - 1]);
            }
        });
    }

    private handle(callback: () => void) {
        if (OperatorAccountStore.hasNonFreeSites) {
            callback();
        } else {
            let site = OperatorAccountStore.data.value?.sites[0];
            if (site) {
                OperatorAccountStore.showFreeDialogForSite(site.id);
            }
        }
    }

    init() {
        shortcuts.reset();
        let items: ShortcutDescriptor[] = [
            {
                shortcut: "Ctrl+Shift+Enter",
                handler: () => {
                    OperatorApplicationPlatform.window.openDevTools();
                }
            },
            {
                shortcut: "Ctrl+C",
                handler: () => {
                    OperatorApplicationEventManager.emit(COPY_SHORTCUT);
                }
            },
            {
                shortcut: "Ctrl+T",
                handler: () => {
                    OperatorApplicationConfigInstance.darkThemeEnabled = !OperatorApplicationConfigInstance.darkThemeEnabled;
                }
            }
        ];
        let list = ShortcutsList.list;
        for (let actionId in list) {
            if (list.hasOwnProperty(actionId)) {
                let shortcut = OperatorApplicationConfigInstance.getShortcut(actionId);
                if (shortcut) {
                    items.push({
                        shortcut,
                        handler: () => {
                            this.handle(() => OperatorApplicationEventManager.emit(actionId));
                        }
                    });
                }
            }
        }

        for (let item of OperatorApplicationConfigInstance.customShortcuts) {
            if (item.shortcut && item.payload && item.typeId) {
                items.push({
                    shortcut: item.shortcut,
                    handler: () => {
                        this.handle(() => {
                            if (item.typeId == CUSTOM_SHORTCUT_USE_MESSAGE_TEMPLATE_TYPE_ID) {
                                OperatorApplicationEventManager.emit(SHORTCUT_INSERT_MESSAGE_TEMPLATE, item.payload);
                            } else if ([CUSTOM_SHORTCUT_SEND_FORM_TYPE_ID, CUSTOM_SHORTCUT_SEND_INFO_TYPE_ID].includes(item.typeId)) {
                                try {
                                    let payload: SendTabShortcutPayloadInterface = JSON.parse(item.payload);
                                    if (payload && payload.showType && payload.tabId) {
                                        OperatorApplicationEventManager.emit(SHORTCUT_SEND_TAB, payload);

                                    }
                                } catch (e) {
                                }
                            } else if (item.typeId == CUSTOM_SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO_TYPE_ID) {
                                OperatorApplicationEventManager.emit(SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO, item.payload);
                            } else if (item.typeId == CUSTOM_SHORTCUT_CHANGE_OPERATOR_STATUS_TYPE_ID) {
                                let payload: CustomShortcutChangeOperatorStatusPayloadInterface = JSON.parse(item.payload);
                                setOperatorStatus(payload.statusId, payload.customStatusId);
                            } else if (item.typeId == CUSTOM_SHORTCUT_START_BOT_TYPE_ID) {
                                OperatorApplicationEventManager.emit(SHORTCUT_START_BOT, item.payload);
                            }
                        });
                    }
                });
            }
        }

        shortcuts.add(items);
    }
}

export const OperatorApplicationShortcutsInstance = new OperatorApplicationShortcuts();